import { el } from 'redom';

import { stringToSVG } from 'utilities';
import {
  convertToOptionsCollection
} from 'utilities/collection';

import SimpleMenu from 'generics/components/simple-menu';

import HelptapEditor from '../../../helpers';

import turnIntoIconString from 'assets/images/turn-into-icon.svg?raw';

import './index.scss';

const turnIntoIcon = stringToSVG(turnIntoIconString);

class TurnIntoButtonMenuPrimaryView {

  constructor(name) {

    this.el = el('p.turn-into-button-primary-view', [
      turnIntoIcon.cloneNode(true),
      el('span', name)
    ]);

  }

}

class TurnIntoButton {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.mainMenu = configuration.menu;
    this.activeNodePath = configuration.activeNodePath;

    this.menu = new SimpleMenu({
      id: 'turn-into-menu',
      name: 'Turn into',
      PrimaryContentView: TurnIntoButtonMenuPrimaryView,
      optionsDisplaySide: 'right',
      options: convertToOptionsCollection(HelptapEditor.conversion.getCompatibleTransitions(this.editor, this.activeNodePath), 'name', 'type')
    });

    this.menu.registerClickEvent(this.handleTransistionSelect.bind(this));

    this.el = el('button#turn-into-button', [this.menu]);

  }

  handleTransistionSelect(event, option) {
    this.mainMenu.onClose();
    HelptapEditor.conversion.convertNode(this.editor, this.node, option.object.type, this.activeNodePath);
  }

  update(configuration) {}

}

export default TurnIntoButton;